import Vue from 'vue';
import VueI18n from 'vue-i18n';
import en_GB from './en_GB.json'; // eslint-disable-line

Vue.use(VueI18n);

const messages = {
  'en-GB': en_GB,
};

const dateTimeFormats = {
  'en-GB': {
    short: {
      year: 'numeric',
      month: 'short',
      day: 'numeric',
    },
    long: {
      year: 'numeric',
      month: 'short',
      day: 'numeric',
      weekday: 'short',
      hour: 'numeric',
      minute: 'numeric',
    },
  },
};

export default new VueI18n({
  locale: navigator.language,
  dateTimeFormats,
  fallbackLocale: 'en-GB',
  messages,
});
